import { AppBarSubmenuItem } from "@iventis/components";

export enum DevSubmenuItemType {
    CACHE = "cache",
}

export const devSubMenuItems: AppBarSubmenuItem[] = [{ id: DevSubmenuItemType.CACHE, name: "Cache", pageIcon: "database", sidePanelIcon: "database" }];
